import React,{useState} from 'react';
import _ from 'lodash';
import FileViewer from 'react-file-viewer';
import Modal from 'react-responsive-modal';
import { Card, CardText } from 'material-ui';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

const index = props => {
  const {data, open, onClose} = props;

  let typeFile = '';
  if (data && data.preview ){
    const fileChunk = _.split(data.name,'.');
    typeFile = fileChunk[fileChunk.length - 1];
  }

  return(
    <Modal closeOnEsc={false}
    little
    modalClassName="col-md-10"
    open={open}
    onClose={onClose}>
    <h5 className="mt-0">{ data ? data.name : ''}</h5>
    { data && data.preview!==false &&
      <Card>
        <CardText>
          <div className="col-md-12 p-0">
            { ( (typeFile !== 'doc' ) && (typeFile !== 'xls') && (typeFile !== 'xlsx')) &&
              <FileViewer
              width="100%" height="400px"
              fileType={typeFile}
              filePath={data.preview}
              onError={(e) => {console.log(e, 'error in file-viewer');}}/>
            }
            { ( (typeFile === 'doc' ) || (typeFile === 'xls')) && typeFile !== 'xlsx' &&
              <iframe src={data.preview} frameBorder="0" width="100%" height="400px"></iframe>
            }
            {(typeFile === 'xlsx' ) &&
              <div className="table-responsive">
                    <Promise data={data}/>
              </div>
            }
          </div>
        </CardText>
      </Card>
    }
  </Modal>
  );
};

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <div>
            {children}
        </div>
      )}
    </div>
  );
}

const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// const renderExcel = ws => {
//   let excel = XLSX.utils.sheet_to_json(ws, {header:1});
//   for(var i = 0; i < excel.length; i ++){
//     for(var j = 0; j < excel[i].length; j ++){
//       if(excel[i][j] == undefined){
//         excel[i][j] = " ";
//       }
//     } 
//   }
//   return excel;
// };

// const renderSheets = wb => {
//   let array = [];
//   for(var i = 0; i < wb.SheetNames.length; i++){
//     const wsname = wb.SheetNames[i];
//     const ws = wb.Sheets[wsname];
//     array.push([wsname,renderExcel(ws)])
//   }
//   return array;
// }

const Promise = ((props) => {
  const [excel,setExcel] = useState('');
  const [firstTime, setFirtTime] = useState(true);
  const [value, setValue] = React.useState(0);
  const {data} = props;
  const reader = new FileReader();
  reader.readAsBinaryString(data);
  reader.onload = (e) => {
    // const bstr = e.target.result;
    // const wb = XLSX.read(bstr, {type:'binary'});
    // if(firstTime){
    //   let excel = renderSheets(wb);
    //   setExcel(excel);
    //   setFirtTime(false);
    // }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  return (
    <div>

     {excel &&
        <div style={{maxHeight: 500}}>
              <AppBar position="static">
                <Tabs value ={value} onChange={handleChange} aria-label="excel reader">
                {excel.map((item,index) => (
                    
                    <Tab key ={index} label={item[0]}  {...a11yProps({index})} />
                    
                ))}
                </Tabs>
              </AppBar>
              {excel.map((item,index) => (
                    <TabPanel key={index}  value={value} index={index}>
                      <TableContainer>
                        <Table size="small" aria-label="a dense table">
                          <TableBody>
                            {item[1].map((rows,index) => (
                              <TableRow key={index}>
                                {
                                  rows.map((row,index) => (
                                    <TableCell key = {index} component="th" scope="row">
                                      {row}
                                    </TableCell>
                                  ))
                                }
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </TabPanel>
              ))}
        </div>
     }
    </div>
  )
})

export default index;


// WEBPACK FOOTER //
// ./routes/app/components/Agent/PreviewFileModal/index.js